import React, { useState } from 'react';
import { apiEnvInfo, OPENAPI_BASE_PATH } from '../utils/apiEnv';
import { alertDialog } from '../utils/dialog';

// OpenAPI 接入信息卡片 (环境 + SDK / HTTP 地址): 拿到 token 的人还得知道往哪个环境、哪个地址发 ——
// 直接摆在页面上, 不用口头问. API Token 页与平台文档 · SDK 接口页共用 (2026-10-08 从 TokenList 抽出).
function ApiAccessInfo() {
    const apiEnv = apiEnvInfo();
    const [copiedField, setCopiedField] = useState('');
    const copyText = async (field: string, text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopiedField(field);
            window.setTimeout(() => setCopiedField(''), 1500);
        } catch {
            alertDialog('复制失败, 请手动选中复制');
        }
    };

    return (
        <div
            className={`card p-4 space-y-2.5 ${apiEnv.isProd ? 'border-amber-300 bg-amber-50' : ''}`}
        >
            <div className="flex items-center gap-2 text-sm font-semibold text-slate-700">
                接入信息
                <span
                    className={`px-1.5 py-0.5 rounded text-[11px] ${
                        apiEnv.isProd
                            ? 'bg-amber-500 text-white'
                            : 'bg-slate-100 text-slate-500'
                    }`}
                >
                    {apiEnv.envLabel}
                </span>
                {apiEnv.isProd && (
                    <span className="text-[11px] text-amber-700 font-normal">
                        当前是<b>生产</b>环境，这里的 token 请勿用于测试
                    </span>
                )}
            </div>
            {apiEnv.sdkBaseURL ? (
                <div className="space-y-1.5 text-xs">
                    <div className="flex items-center gap-2">
                        <span className="w-40 shrink-0 text-slate-400">
                            SDK baseURL
                        </span>
                        <code className="flex-1 font-mono bg-slate-50 border border-slate-200 rounded px-2 py-1 break-all select-all">
                            {apiEnv.sdkBaseURL}
                        </code>
                        <button
                            type="button"
                            className="btn-ghost shrink-0"
                            onClick={() => copyText('sdk', apiEnv.sdkBaseURL)}
                        >
                            {copiedField === 'sdk' ? '已复制 ✓' : '复制'}
                        </button>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="w-40 shrink-0 text-slate-400">
                            直接发 HTTP
                        </span>
                        <code className="flex-1 font-mono bg-slate-50 border border-slate-200 rounded px-2 py-1 break-all select-all">
                            {apiEnv.httpBaseURL}/…
                        </code>
                        <button
                            type="button"
                            className="btn-ghost shrink-0"
                            onClick={() => copyText('http', apiEnv.httpBaseURL)}
                        >
                            {copiedField === 'http' ? '已复制 ✓' : '复制'}
                        </button>
                    </div>
                    <div className="text-[11px] text-slate-400 pt-0.5">
                        SDK 只填上面那行，
                        <code className="font-mono">
                            {OPENAPI_BASE_PATH}
                        </code>{' '}
                        由 material-client 内部拼接，别自己带上去。地址里的
                        <code className="font-mono"> /material </code>
                        是网关前缀，不能省。
                    </div>
                </div>
            ) : (
                <div className="text-xs text-rose-600">
                    未配置 VITE_REQUEST_BASE_URL，无法给出接入地址（本地开发用
                    .env.localhost）。
                </div>
            )}
        </div>
    );
}

export default ApiAccessInfo;
